import { FiltersActionTypes } from './actionTypes';
import { FiltersActions } from './actions';
import { DateRangeType } from './storeTypes';

type Dispatch = (action: FiltersActionTypes) => void;

export const setDateRange = (dateRange: DateRangeType) => async (dispatch: Dispatch) => {
	dispatch(FiltersActions.setDateRange(dateRange));
};
